export enum TimelineState {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
    ACTIVE = 'ACTIVE'
}
